import React, { useState } from "react";
import Cover from "../../components/cover";
import Navbar from "../../components/navbar";
import TilesRow from "../../components/tilesRow";
import Modal from "../../components/modal";
import TileDetails from "../../components/tileDetails";
import ReactPlayer from "react-player";

// https://docs.aws.amazon.com/prescriptive-guidance/latest/patterns/deploy-a-react-based-single-page-application-to-amazon-s3-and-cloudfront.html
export default function MainPage() {
  const stateInitial = {
    /** Toggles the modal when a movie is clicked. */
    toggleModal: false,
    /** Holds the movie information for a single movie. */
    tileDetails: {},
  };

  const [state, setState] = useState(stateInitial);

  const closeModal = () => {
    setState({ toggleModal: false });
  };

  return (
    <div className="container-main-page">
      {/* navbar */}
      <Navbar />

      {/* cover */}
      <Cover />

      <Modal
        show={state.toggleModal}
        modalClosed={closeModal}
        backgroundImg={state.tileDetails?.backgroundImg}
      >
        {state.tileDetails != null &&
          state.tileDetails.youtubeVideoURL != null && (
            <div>
              <ReactPlayer
                playing
                controls
                className="modal__videoContainer"
                width="100%"
                height="60%"
                url={state.tileDetails.youtubeVideoURL}
              />
            </div>
          )}
        {state.tileDetails != null && (
          <TileDetails tileDetails={state.tileDetails} />
        )}
      </Modal>

      {/* resuable component tile */}
      <div style={{ paddingTop: 16 }}>
        {/* Rest of the tiles */}
        <TilesRow
          onChange={(props) => {
            setState(props);
          }}
          title="Passion Projects"
        />
        <TilesRow
          onChange={(props) => {
            setState(props);
          }}
          title="Designs"
        />
        <TilesRow
          onChange={(props) => {
            setState(props);
          }}
          title="Activities"
        />
      </div>
    </div>
  );
}
